import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementStore from '../statement-store'
import setStatementQuery from './set-statement-query'

export default async function toggleJybedByFollowing(context: BareActionContext<StatementState, RootState>)
{
    setStatementQuery(context)

    return
}
